import React, {useState, useEffect, useRef} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {PURPLE} from "../../../constants/general-constants";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

export default function UtilisationChartLine({}){
	
	const chartId = "utilisationchartline";
	
	const chartData = [
		{label:'Mon:09:00', utilisation:"30", capacity:"20"},
		{label:'Mon:11:00', utilisation:"40", capacity:"22"},
		{label:'Mon:13:00', utilisation:"70", capacity:"45"},
		{label:'Mon:14:00', utilisation:"70", capacity:"60"},
		{label:'Mon:17:00', utilisation:"60", capacity:"60"},
		{label:'Tue:09:00', utilisation:"30", capacity:"20"},
		{label:'Tue:11:00', utilisation:"40", capacity:"12"},
		{label:'Tue:13:00', utilisation:"70", capacity:"45"},
		{label:'Tue:14:00', utilisation:"70", capacity:"60"},
		{label:'Tue:17:00', utilisation:"60", capacity:"60"},
		{label:'Wed:09:00', utilisation:"30", capacity:"20"},
		{label:'Wed:11:00', utilisation:"40", capacity:"22"},
		{label:'Wed:13:00', utilisation:"70", capacity:"45"},
		{label:'Wed:14:00', utilisation:"70", capacity:"60"},
		{label:'Wed:17:00', utilisation:"60", capacity:"90"},
		{label:'Thu:09:00', utilisation:"30", capacity:"20"},
		{label:'Thu:11:00', utilisation:"40", capacity:"22"},
		{label:'Thu:13:00', utilisation:"70", capacity:"45"},
		{label:'Thu:14:00', utilisation:"70", capacity:"60"},
		{label:'Thu:17:00', utilisation:"60", capacity:"60"},
		{label:'Fri:09:00', utilisation:"30", capacity:"20"},
		{label:'Fri:11:00', utilisation:"40", capacity:"22"},
		{label:'Fri:13:00', utilisation:"70", capacity:"45"},
		{label:'Fri:14:00', utilisation:"70", capacity:"60"},
		{label:'Fri:17:00', utilisation:"60", capacity:"60"},
	];
	
	const graphs = [
		{title:"Utilisation", keyColumn:"utilisation", color:"darkgreen"},
		{title:"% Capacity", keyColumn:"capacity", color:"darkblue"}
	];
	
	useEffect(() => {
		let categoryKey = "label";
		
		let x = am4core.create(chartId, am4charts.XYChart);
		x.paddingTop = 0;
		x.paddingRight = 0;
		x.paddingLeft = 0;
		x.paddingBottom = 0;
		let categoryAxis = x.xAxes.push(new am4charts.CategoryAxis());
		categoryAxis.renderer.grid.template.strokeOpacity = 0;
		categoryAxis.renderer.labels.template.strokeOpacity=0;
		categoryAxis.renderer.labels.template.fillOpacity=0;
		categoryAxis.dataFields.category=categoryKey;	
		let valueAxis = x.yAxes.push(new am4charts.ValueAxis());
		valueAxis.renderer.grid.template.strokeOpacity = 0;
		valueAxis.renderer.labels.template.strokeOpacity=0;
		valueAxis.renderer.labels.template.fillOpacity=0;
		
		for(let i=0; i<graphs.length; i++){
	 		let series = x.series.push(new am4charts.LineSeries());
	 		series.name = graphs[i].title;
	    series.dataFields.categoryX = categoryKey;
	    series.dataFields.valueY = graphs[i].keyColumn;
	    series.fill = graphs[i].color;
	    series.stroke = graphs[i].color;
	    series.tooltipText = graphs[i].title + " ({categoryX}): {valueY}";
  		series.tooltip.label.wrap=true;
  		series.tooltip.label.width=300;
  		series.tooltip.label.fill='black';
  		series.strokeWidth=2;
  		 series.tensionX = 0.8;
	  }
	   
	   x.cursor = new am4charts.XYCursor();
	   
			x.data = chartData;
			chart.current = x;
	}, [chartData, graphs]);
	
	const chart = useRef(null);
	
	
	
	const thisContainer = {
		display:'flex',
		marginLeft:"20px",
		marginTop:"0px",
		width:"calc(100% - 32px)",
		height:"130px",
		borderRadius:"5px",
		backgroundColor:"#f5f5f5"
	};
	
	const chartContainer ={ 
		display:"flex",
		width:"calc(100% - 300px)",
		height:"130%"
	};
	
	const peakContainer = {
		display:"flex",
		width:"260px",
		margin:"20px",
		flexDirection:"column"
	};
	
	const peakTitleContainer ={
		display:"flex",
		marginLeft:"100px"
	};
	
	const peakTitle = {
		display:"flex",
		width:"80px",
		height:"20px",
		alignItems:"center",
		fontSize:'14px',
		justifyContent:"space-around"
	};
	
	const peakComponent = {
		display:"flex",
		width:"100%",
		height:"30px",
		alignItems:"center",
		marginBottom:"10px"
	};
	
	const peakComponentLabel = {
		display:"flex",
		width:"100px",
		fontSize:"14px"
	};
	
	const peakComponentPeak = {
		display:"flex",
		width:"50%",
		height:"100%",
		backgroundColor:"black",
		color:"white",
		alignItems:"center",
		justifyContent:"space-around",
		borderTopLeftRadius:"15px",
		borderBottomLeftRadius:"15px"
	};
	
	const peakComponentMin = {
		display:"flex",
		width:"50%",
		height:"100%",
		backgroundColor:"darkgrey",
		color:"white",
		alignItems:"center",
		justifyContent:"space-around",
		borderTopRightRadius:"15px",
		borderBottomRightRadius:"15px"
	};
	
	return (
		<div style={thisContainer}>
			<div style={chartContainer} id={chartId}>
			
			</div>
			<div style={peakContainer}>
				<div style={peakTitleContainer}>
					<div style={peakTitle}>
						Max
					</div>
					<div style={peakTitle}>
						Min
					</div>
				</div>
				<div style={peakComponent}>
					<div style={peakComponentLabel}>
						Utilisation
					</div>
					<div style={{...peakComponentPeak, backgroundColor:'darkgreen'}}>
						98%
					</div>
					<div style={peakComponentMin}>
						56%
					</div>
				</div>
				<div style={peakComponent}>
					<div style={peakComponentLabel}>
						%Capacity
					</div>
					<div style={{...peakComponentPeak, backgroundColor:'darkblue'}}>
						77%
					</div>
					<div style={peakComponentMin}>
						16%
					</div>
				</div>
			</div>
		</div>
	);
}